import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { RiLockPasswordLine, RiLogoutCircleRLine } from "react-icons/ri";
import React from "react";
import IconComponent from "../common/IconComponent";
import { openDialog } from "../dialog/dialogSlice";
import ListingAvatar from "../common/ListingAvatar";

const UserProfile = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const loginDetails = useAppSelector((state) => state.login.loginDetails);
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);
  const handleMenuClick = () => {
    setIsMenuOpen((prev) => !prev);
  };

  const FBTOKEN = localStorage.getItem("FBTOKEN");
  const FBUserID = localStorage.getItem("FBUserID");

  const handleLogout = () => {
    localStorage.clear();
    if (FBTOKEN !== null) {
      localStorage.setItem("FBTOKEN", FBTOKEN);
    }
    if (FBUserID !== null) {
      localStorage.setItem("FBUserID", FBUserID);
    }
    navigate("/login");
    setIsMenuOpen(false);
  };
  const handleChangePassword = () => {
    setIsMenuOpen(false);
    dispatch(openDialog("changePassword"));
  };

  React.useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (!event.target.closest(".userprofile")) {
        setIsMenuOpen(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  return (
    <div className="userprofile position-relative" onClick={handleMenuClick}>
      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
        <div
          style={{
            display: "flex",
            alignItems: "end",
            flexDirection: "column",
            color: "#fff",
            lineHeight: "1rem",
          }}
        >
          <strong>{loginDetails?.FullName || ""}</strong>
          <strong style={{ fontSize: 13, fontWeight: 300 }}>
            {loginDetails?.UserType || ""}
          </strong>
        </div>
        <ListingAvatar
          className="userprofile-avatar"
          src={loginDetails?.UserImage && loginDetails?.UserImage !== "undefined" ? loginDetails?.UserImage : undefined}
          alt="user image"
          fallbackText={loginDetails?.FullName ? loginDetails.FullName.split(" ").slice(0, 2).map((n: string) => n[0]).join("").toUpperCase() : ""}
          size={38}
        />

        {/* <Avatar size={40} gap={0} icon={} /> */}
      </div>
      {isMenuOpen && (
        <div className="userprofile-dropdown">
          <ul>
            <li onClick={handleChangePassword}>
              <IconComponent icon={RiLockPasswordLine} /> &nbsp;Change Password
            </li>
            <li onClick={handleLogout} style={{ color: "red" }}>
              <IconComponent icon={RiLogoutCircleRLine} /> &nbsp;Log Out
            </li>
          </ul>
        </div>
      )}
    </div>
  );
};

export default UserProfile;
